import { useState, useEffect, useRef } from 'react'
import { useTitle } from '../../../hooks/useTitle'
import { IMAGE_URL } from '../../../constants'
import chatbotApi from '../../../services/chatbotApi'
import SwiperCore, { FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import * as S from './styles'
import CatalogProductCard from '../../../components/ChatbotCatalog/CatalogProductCard'
import CatalogCart from '../../../components/ChatbotCatalog/CatalogCart'
import CatalogBackToTop from '../../../components/ChatbotCatalog/CatalogBackToTop'
import Loading from '../../../commons/Loading';
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll';

const CatalogHome = () => {
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true);
  SwiperCore.use([FreeMode]);

  const getCategories = async () => {
    if (isLoading || !hasMore) return;

    setIsLoading(true);
    const response = await chatbotApi.get(`/api/v2/Chatbot/FirstProductsByCategory?OnlyB2B=true&Page=${page}&Size=5`);
    const data = response.data.response.data;

    if (data.length === 0) {
      setHasMore(false);
      setIsLoading(false);
      return;
    }

    setCategories(prev => [...prev, ...data]);
    setPage(prev => prev + 1);
    setIsLoading(false);
  };

  const renderProductsSwiper = (products) => {
    return (
      <S.CatalogProductsSwiper
        slidesPerView="auto"
        spaceBetween={12}
        freeMode={true}
      >
        {
          products.map(product => (
            <S.CatalogSlide key={product.id}>
              <CatalogProductCard product={product} />
            </S.CatalogSlide>
          ))
        }
      </S.CatalogProductsSwiper>
    )
  }

  const loaderRef = useInfiniteScroll({
    onEndReached: getCategories,
    isLoading,
    hasMore,
  });

  useEffect(() => {
    getCategories()
  }, [])

  useTitle('Catálogo de Produtos')

  return (
    <S.Catalog>
      {isLoading && (
        <S.LoadingWrapper>
          <Loading />
        </S.LoadingWrapper>
      )}
      <S.CatalogHome>
        {
          categories?.map(category => (
            category.products?.length > 0 && (
              <>
                <S.CatalogHomeCategories key={category.categoryId}>
                  <S.CatalogCategorieTitleWrapper>
                    <S.CatalogCategorieTitle>
                      {category.category}
                    </S.CatalogCategorieTitle>
                    <S.SeeMoreBtn to={`/chatbot-catalog/category/${category.categoryId}`}>
                      Ver mais
                    </S.SeeMoreBtn>
                  </S.CatalogCategorieTitleWrapper>
                  <S.SwiperProductsWrapper>
                    {renderProductsSwiper(category.products)}
                  </S.SwiperProductsWrapper>
                </S.CatalogHomeCategories>
              </>
            )
          ))
        }
      </S.CatalogHome>
      <CatalogCart />
      <div ref={loaderRef} style={{ height: '1px' }} />
      <CatalogBackToTop />
    </S.Catalog>
  )
}

export default CatalogHome;
